import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/board.json";

export const useBoard = () => useSourceFlowCollection(data);

export default useBoard;
